/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AutocompleteList } from '../models/autocomplete-list';
import { SelectionTagSelectionValueTreeList } from '../models/selection-tag-selection-value-tree-list';
import { SingleLineStringTagSuggestionList } from '../models/single-line-string-tag-suggestion-list';
import { tagGetSelectionTagSelectionValueTreeList } from '../fn/tag/tag-get-selection-tag-selection-value-tree-list';
import { TagGetSelectionTagSelectionValueTreeList$Params } from '../fn/tag/tag-get-selection-tag-selection-value-tree-list';
import { tagGetSingleLineStringTagSuggestionList } from '../fn/tag/tag-get-single-line-string-tag-suggestion-list';
import { TagGetSingleLineStringTagSuggestionList$Params } from '../fn/tag/tag-get-single-line-string-tag-suggestion-list';
import { tagGetTagAutocompleteList } from '../fn/tag/tag-get-tag-autocomplete-list';
import { TagGetTagAutocompleteList$Params } from '../fn/tag/tag-get-tag-autocomplete-list';
import { tagGetUserSelectionTagUserList } from '../fn/tag/tag-get-user-selection-tag-user-list';
import { TagGetUserSelectionTagUserList$Params } from '../fn/tag/tag-get-user-selection-tag-user-list';
import { UserSelectionTagUserList } from '../models/user-selection-tag-user-list';

@Injectable({ providedIn: 'root' })
export class TagService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tagGetTagAutocompleteList()` */
  static readonly TagGetTagAutocompleteListPath = '/tag/autocomplete/list';

  /**
   * Get tag autocomplete list.
   *
   * Get tag autocomplete list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tagGetTagAutocompleteList()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagGetTagAutocompleteList$Response(params?: TagGetTagAutocompleteList$Params, context?: HttpContext): Observable<StrictHttpResponse<AutocompleteList>> {
    const obs = tagGetTagAutocompleteList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get tag autocomplete list.
   *
   * Get tag autocomplete list
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tagGetTagAutocompleteList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagGetTagAutocompleteList(params?: TagGetTagAutocompleteList$Params, context?: HttpContext): Observable<AutocompleteList> {
    const resp = this.tagGetTagAutocompleteList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AutocompleteList>): AutocompleteList => r.body)
    );
  }

  /** Path part for operation `tagGetSelectionTagSelectionValueTreeList()` */
  static readonly TagGetSelectionTagSelectionValueTreeListPath = '/tag/selection/{tagId}/selection-value/tree-list';

  /**
   * Get selection tag selection values.
   *
   * Get selection tag selection values
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tagGetSelectionTagSelectionValueTreeList()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagGetSelectionTagSelectionValueTreeList$Response(params: TagGetSelectionTagSelectionValueTreeList$Params, context?: HttpContext): Observable<StrictHttpResponse<SelectionTagSelectionValueTreeList>> {
    const obs = tagGetSelectionTagSelectionValueTreeList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get selection tag selection values.
   *
   * Get selection tag selection values
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tagGetSelectionTagSelectionValueTreeList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagGetSelectionTagSelectionValueTreeList(params: TagGetSelectionTagSelectionValueTreeList$Params, context?: HttpContext): Observable<SelectionTagSelectionValueTreeList> {
    const resp = this.tagGetSelectionTagSelectionValueTreeList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SelectionTagSelectionValueTreeList>): SelectionTagSelectionValueTreeList => r.body)
    );
  }

  /** Path part for operation `tagGetSingleLineStringTagSuggestionList()` */
  static readonly TagGetSingleLineStringTagSuggestionListPath = '/tag/single-line-string/{tagId}/suggestion/list';

  /**
   * Get single line string tag suggestions.
   *
   * Get single line string tag suggestions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tagGetSingleLineStringTagSuggestionList()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagGetSingleLineStringTagSuggestionList$Response(params: TagGetSingleLineStringTagSuggestionList$Params, context?: HttpContext): Observable<StrictHttpResponse<SingleLineStringTagSuggestionList>> {
    const obs = tagGetSingleLineStringTagSuggestionList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get single line string tag suggestions.
   *
   * Get single line string tag suggestions
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tagGetSingleLineStringTagSuggestionList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagGetSingleLineStringTagSuggestionList(params: TagGetSingleLineStringTagSuggestionList$Params, context?: HttpContext): Observable<SingleLineStringTagSuggestionList> {
    const resp = this.tagGetSingleLineStringTagSuggestionList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SingleLineStringTagSuggestionList>): SingleLineStringTagSuggestionList => r.body)
    );
  }

  /** Path part for operation `tagGetUserSelectionTagUserList()` */
  static readonly TagGetUserSelectionTagUserListPath = '/tag/user-selection/{tagId}/user/list';

  /**
   * Get user selection tag users.
   *
   * Get user selection tag users
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tagGetUserSelectionTagUserList()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagGetUserSelectionTagUserList$Response(params: TagGetUserSelectionTagUserList$Params, context?: HttpContext): Observable<StrictHttpResponse<UserSelectionTagUserList>> {
    const obs = tagGetUserSelectionTagUserList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get user selection tag users.
   *
   * Get user selection tag users
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tagGetUserSelectionTagUserList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagGetUserSelectionTagUserList(params: TagGetUserSelectionTagUserList$Params, context?: HttpContext): Observable<UserSelectionTagUserList> {
    const resp = this.tagGetUserSelectionTagUserList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserSelectionTagUserList>): UserSelectionTagUserList => r.body)
    );
  }

}
